module.exports = __webpack_public_path__ + "static/media/rotate.666cbdfc.svg";